import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberFormatPipe',
    standalone: false
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: number, decimalSeparator: string = '.'): string {
    // Format the number with grouping using default locale
    const formattedValue = value.toLocaleString(undefined, { useGrouping: true });

    // Replace the default decimal separator with the specified one
    return formattedValue.replace(/\./g, decimalSeparator);
  }
}